export default __webpack_public_path__ + "static/media/Plus 4.16ab41f5.svg";